import {AbstractControl} from '@angular/forms';

export function verifiedInvalid(control: AbstractControl): boolean {
  return control.invalid && control.dirty && control.touched;
}
